export const heroStats = [
  { label: 'Placement Revenue', value: '10M+', prefix: '$', suffix: '' },
  { label: 'Professional Placements', value: '70+', prefix: '', suffix: '' },
  { label: 'Speaking Events', value: '2', prefix: '', suffix: ' Conferences' },
];

export const featuredRecommendations = [
  {
    id: 1,
    name: 'Bryan Walker',
    role: 'Project Manager',
    endorsement: 'From our first conversation, Jeff was professional, transparent, and genuinely invested in finding the right fit for my skills and career goals. He took the time to understand what I was looking for, provided thoughtful guidance throughout the process, and kept me updated every step of the way.',
  },
  {
    id: 2,
    name: 'Farooq Ogunfuyi',
    role: 'MS SCM at Boeing',
    endorsement: 'Jeff was instrumental in my early career development and played a major role in creating and properly leveraging LinkedIn as a professional platform. His guidance directly influenced the opportunities I pursued, and even lead me to secure my role at Boeing.',
  },
  {
    id: 3,
    name: 'Adam Foulkrod',
    role: 'Senior Construction Administration Lead at Arup',
    endorsement: 'Jeff helped me find a new job with a better schedule as well as a higher salary. He communicated with me as much as necessary and also negotiated well on my behalf to help increase the initial offer.',
  },
];

export const clientsServed = [
  { id: 1, name: 'Boeing', industry: 'Aerospace' },
  { id: 2, name: 'Arup', industry: 'Engineering' },
  { id: 3, name: 'Arnold Construction', industry: 'Construction' },
  { id: 4, name: 'MainFrame Solutions', industry: 'Tech and Recruiting' },
  { id: 5, name: 'Arnold PIS', industry: 'Pipeline Integrity' },
];

export const speakingVenues = [
  {
    id: 1,
    name: 'Gulf Coast Symposium on HR Issues',
    year: '2026',
    topic: 'Reducing Hiring Risk Through Structured Evaluation and Responsible AI Use',
  },
  {
    id: 2,
    name: 'Regional Hispanic Contractors Association (RHCA)',
    year: '2026',
    topic: 'OSHA Safety & AI Roundtable',
  },
  {
    id: 3,
    name: 'HR Houston Seminar',
    year: '2026',
    topic: 'Reducing Hiring Risk Through Structured Evaluation and Responsible AI Use',
  },
];